import { MouseEvent, useEffect, useMemo, useState } from 'react';
import cn from 'classnames';

import Button from '@/components/common/Button';

type Props = {
  currentPage: number;
  totalPage: number;
  onClickPage: (page: number) => void;
  size?: number;
};

const Pagination = ({ currentPage, totalPage, onClickPage, size = 10 }: Props) => {
  const [pageIndex, setPageIndex] = useState(0);
  const maxPageIndex = useMemo(() => Math.floor((totalPage - 1) / size), [totalPage, size]);

  useEffect(() => {
    setPageIndex(Math.floor((currentPage - 1) / size));
  }, [currentPage, size]);

  const onClickPaging = (page: number) => (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onClickPage(page);
  };

  const increasePageIndex = () => {
    const newIndex = pageIndex + 1;
    if (newIndex > maxPageIndex) return;

    setPageIndex(newIndex);
    onClickPage(newIndex * size + 1);
  };

  const decreasePageIndex = () => {
    const newIndex = pageIndex - 1;
    if (newIndex < 0) return;

    setPageIndex(newIndex);
    onClickPage(newIndex * size + 1);
  };

  // 서버에서 내려온 데이터가 없을 경우 페이지네이션 노출하지 않음 (기획 공통 스펙)
  if (totalPage <= 0) return null;

  return (
    <div className="paging_comm">
      <div className="inner_paging">
        <Button className="btn_prev" onClick={decreasePageIndex} disabled={pageIndex === 0}>
          <span className="ico_wallet ico_prev">이전</span>
        </Button>
        <span className="screen_out">현재페이지</span>
        {Array.from({ length: size }, (_, index) => size * pageIndex + index + 1).map(
          (pageNum) =>
            pageNum <= totalPage && (
              <a
                key={pageNum}
                href="#"
                className={cn('link_page', { current_g: pageNum === currentPage })}
                onClick={onClickPaging(pageNum)}
              >
                {pageNum}
              </a>
            )
        )}
        <Button className="btn_next" onClick={increasePageIndex} disabled={pageIndex === maxPageIndex}>
          <span className="ico_wallet ico_prev">다음</span>
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
